import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, FormControl, Validators, AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import * as UserDataConfig from '../../config/user-data.config';
import * as UserDataConfigforTitle from '../../../user-details/config/user-data.config';

import { AnalyticsService, FormValidationsService, AnnuitantDetailService, LoaderService, ButtonService, ApplicationDataCaptureService, SERVICE_END_POINT, UtilService, AuthService } from 'src/app/shared';
import { CMSResolver } from '../../../../core/resolvers/cms.resolver';
import { CmsService } from '../../../../core/cms/service.service';
import { AppState } from '../../../../store/state/app.state';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { RegistrationDetails } from '../../../../model/ngrx/registration-details.model';
import { PersonalDetails } from '../../../../model/ngrx/personal-details.model';
import * as beneficiaryDetailsActions from '../../../../store/actions/beneficiary-details.actions';
import { AlertModal } from 'src/app/model/alert';
import { Location } from '@angular/common';
import { EmailMatch } from 'src/app/shared/validators/email-match.validators';
import { BeneficiaryDetails, YourPersonalDetails } from 'src/app/model/ngrx';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ConfigLoaderService } from 'src/app/shared/services/api-services/configLoader.service';


@Component({
  selector: 'app-beneficiary-details',
  templateUrl: './beneficiary-details.component.html',
  styleUrls: ['./beneficiary-details.component.scss']
})


export class BeneficiaryDetailsComponent implements OnInit, OnDestroy{



  public ageValidatorFlag = false;
  // tslint:disable-next-line: max-line-length
  protected alertModalConfig: AlertModal;
  // tslint:disable-next-line: max-line-length
  public ageAlertModalConfig: AlertModal = new AlertModal('alert', 'You\'re outside the age range we typically deal with', '', 'Proceed', '', '');
  public removeAlertModalConfig: AlertModal = new AlertModal('alert', 'Remove beneficiary', 'Are you sure you want to remove Beneficary', 'Remove', 'Cancel', '');
  displayAlert = false;
  public userInputDetail = UserDataConfigforTitle.ElementsConfig;
  public titleConfig = this.userInputDetail.titleConfig;
  displayTooltipAlert: boolean = false;
 tooltipModal;
  public tooltipModalConfig: AlertModal;
  public afterApplyDetail = UserDataConfig.ElementsConfig;
  // protected titleConfig = this.afterApplyDetail.titleConfig;
  public fnameTextCodeConfig = this.afterApplyDetail.forenameTextConfig;
  public firstNameToolTipInfoCodeConfig = this.afterApplyDetail.beneficiaryFirstNameToolTipInfoConfig;
  public lnameTextCodeConfig = this.afterApplyDetail.surnameTextConfig;
  public dobCodeConfig = this.afterApplyDetail.dobConfig;
  private CMSData;
  beneficiaryDetailForm: UntypedFormGroup;

  beneficiaryDetail: Partial<BeneficiaryDetails[]> = [];
  beneficiaryDetailStore: Observable<BeneficiaryDetails[]>;

  private subscription: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  contentData;
  cmsRegistrationData;
  addressSeachEnabled = false;
  loadingFlag = false;
  protected otherTitleList: any;
  public otherTitle = [];
  enableOtherTitle = false;
  public array1 = [];
  productName: string;
  GuranttedIncome: number;
  ValueProtection: string;
  benefitBasisData = [];
  protected resposeJsonQuoteCaptureStore: {};
  protected resultQuote: {};
  showGuranteedText = false;
  showVpText = false;
  yourPersonalDetailsStore: Observable<YourPersonalDetails[]>;
  yourPersonalDetails: YourPersonalDetails;
  yourPersonalDetailsStoreSubscription: Subscription;
  addressline2Mandatory = false;
  postcodeCheck: string;
  isDelete: boolean = false;
  deleteRecordNumber: number = 0;
  getTotalError = false;
  isDateInputRequired:boolean =false;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private annuitantservice: AnnuitantDetailService,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private utilService: UtilService,
    // tslint:disable-next-line:variable-name
    private _location: Location,
    public el: ElementRef,
    private analyticsService: AnalyticsService,
    private store: Store<AppState>, private authService: AuthService,
   private configLoaderService: ConfigLoaderService) {

    // this.postCodeConfig.defaultValue = '';
    this.contentData = this.route.snapshot.data.contentData.beneficiaryDetails;
    this.cmsRegistrationData = this.route.snapshot.data.contentData.registrationDetail;
    this.tooltipModal = this.route.snapshot.data.contentData.tooltipModalConfig;

    this.beneficiaryDetailStore = store.select(STORE_VAL.beneficiary_details);
    /*     susbscribing to bank detail store*/
    this.beneficiaryDetailStore.subscribe((val: any) => {
      if (val && val.length > 0) {
        this.beneficiaryDetail = val[0];
      }
    });

    store.select(STORE_VAL.application_data_response).subscribe(res => {
      if (res && res.length > 0) {
        this.resultQuote = res[0].quoteFundInfo[0];
        this.showGuranteedText = this.resultQuote['guaranteeTerm'];
        this.showVpText = this.resultQuote['valueProtection'];
      }
    });
    /* checking for personal detail values from store */
    this.yourPersonalDetailsStore = store.select(STORE_VAL.your_personal_details);
    this.yourPersonalDetailsStoreSubscription = this.yourPersonalDetailsStore.subscribe(val => {
      if (val && val.length > 0) {
        this.yourPersonalDetails = val[0];
        this.postcodeCheck = val[0].address['postcode'];
        if (this.postcodeCheck && this.postcodeCheck !== 'Not provided') {
          this.addressline2Mandatory = true;
        }
      }
    });
  }
  ngOnInit() {
        this.tooltipModalConfig = this.route.snapshot.data.contentData.tooltipModalConfig;
    this.isDateInputRequired = this.configLoaderService.configuration.isDateInputRequired;

    this.GetCMSDataServiceMapper();

    this.userFormData();
    this.preloadFormData()
    this.ageAlertModalConfig.setContent(this.cmsRegistrationData.ageValidationWarning);
    // tslint:disable-next-line:max-line-length
    this.subscripSaveProgress = this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    // tslint:disable-next-line:max-line-length
    this.subscripLogout = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });


    const obj = new ParentFormAndElmModel(this.beneficiaryDetailForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
  }

  ngOnDestroy() {
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscription = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveProgress() {
    this.saveFormValues();
    this.subscription = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveFormValues() {
    this.store.dispatch(new beneficiaryDetailsActions.RemoveBeneficiaryDetails(0));
    this.store.dispatch(new beneficiaryDetailsActions.AddBeneficiaryDetails(this.beneficiaryDetailForm.value));
  }

  userFormData = () => {

    this.beneficiaryDetailForm = this.fb.group({
      beneficiary: this.fb.array([])
    })
  }

  get Beneficiary(): FormArray {
    return this.beneficiaryDetailForm.get('beneficiary') as FormArray
  }

  preloadFormData() {
    const beneficiaryArray = this.beneficiaryDetailForm.get('beneficiary') as FormArray

    this.beneficiaryDetail.forEach((beneficiary) => {
      if (beneficiary.otherTitle) {
        this.getOtherTitle();

        this.enableOtherTitle = true;

      }
      beneficiaryArray.push(this.fb.group({
        userTitle: [beneficiary.userTitle, [Validators.required]],
        otherTitle: [beneficiary.otherTitle],
        forename: [beneficiary.forename, [Validators.pattern('^.{2,}$')]],
        surname: [beneficiary.surname, [Validators.pattern('^.{2,}$')]],
        dateOfBirth: [beneficiary.dateOfBirth, Validators.required],
        beneficiaryAllocPercentage: [beneficiary.beneficiaryAllocPercentage, [Validators.required, Validators.min(0.01)]],
        addressSearchChecked: [(beneficiary.ukAddressIndicator != '' && beneficiary.ukAddressIndicator != null) ? false : true],
        ukAddressIndicator: [beneficiary.ukAddressIndicator],
        address: this.fb.group({
          addressline1: [beneficiary.address.addressline1, [Validators.required]],
          addressline2: [beneficiary.address.addressline2, [Validators.required]],
          addressline3: [beneficiary.address.addressline3],
          addressline4: [beneficiary.address.addressline4],
          postcode: [beneficiary.address.postcode],
          countryCode: [beneficiary.address.countryCode],
        })
      }))


    })
  }

  newBeneficiaryData(): FormGroup {
    return this.fb.group({
      userTitle: ['', [Validators.required]],
      otherTitle: [''],
      forename: ['', [Validators.required, Validators.pattern('^.{2,}$')]],
      surname: ['', [Validators.required, Validators.pattern('^.{2,}$')]],
      dateOfBirth: ['', Validators.required],
      beneficiaryAllocPercentage: ['', [Validators.required, Validators.min(0.01)]],
      addressSearchChecked: [true],
      ukAddressIndicator: [''],
      address: this.fb.group({
        addressline1: [this.yourPersonalDetails.address.line1, [Validators.required]],
        addressline2: [this.yourPersonalDetails.address.line2],
        addressline3: [this.yourPersonalDetails.address.line3],
        addressline4: [this.yourPersonalDetails.address.line4],
        postcode: [this.yourPersonalDetails.address.postcode],
        countryCode: [''],
      })
    })
  }

  addBeneficiary() {
    this.Beneficiary.push(this.newBeneficiaryData());
  }

  getTotal(): number {

    let total = 0;
    this.Beneficiary.controls.forEach(ben => {
      total += +ben.get('beneficiaryAllocPercentage')?.value || 0
    })

    total = Number(total.toFixed(2));
    return total
  }

  removeBeneficiary(id: number, beneficiary: FormGroup) {
    this.isDelete = true;
    let message = 'Are you sure you want to remove Beneficary ' + id + ': ' + beneficiary.get('forename').value + ' ' + beneficiary.get('surname').value
    this.removeAlertModalConfig.setContent(message);
    this.deleteRecordNumber = id - 1;
  }

  /* null check for the properties */
  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }

  /* save data to store while clicking back */
  OnBackClick() {
    this.saveFormValues();
    this.store.dispatch(new beneficiaryDetailsActions.RemoveBeneficiaryDetails(0));
    this.store.dispatch(new beneficiaryDetailsActions.AddBeneficiaryDetails(this.beneficiaryDetailForm.value.beneficiary));

  }
  /* fetching other title value from service */
  getOtherTitle() {
    this.annuitantservice.getOtherTitle().subscribe(data => {
      this.otherTitleList = data;
    });
    this.otherTitle = this.array1;
  }


  toggleFlag() {
    // this.addressFlag = !this.addressFlag;
  }

  /* check data change for Date of birth to display moddal */
  checkDataChange = (flagArray) => {
    if (flagArray[1] === true) {
      this.ageValidatorFlag = true;
    }
  }


  alertAgePrimaryBtnClick() {
    this.closeAgeModal();
  }
  alertUkAddressPrimaryBtnClick() {
    this._location.back();
  }
  alertAgeSecondaryBtnClick() {
    this.closeAgeModal();
  }

  deleteBeneficiaryRecord(index: number) {
    this.Beneficiary.removeAt(this.deleteRecordNumber);
    this.closeRemoveModal()
  }

  closeModal() {
    this.displayAlert = false;
  }
  closeAgeModal() {
    this.ageValidatorFlag = false;
  }

  closeRemoveModal() {
    this.isDelete = false;
  }

  backtoPrevious() {

    this._location.back();
  }
  /* validation of other title */
  triggerotherTitleValidation() {
    this.beneficiaryDetailForm.updateValueAndValidity();
  }

  /* display other title if title is selected as other title */
  detectChange(beneficiary: FormGroup) {
    // const otherTitleControlname = this.registrationDetailForm.get('otherTitle');
    const othTitle = beneficiary.get('otherTitle');
    if (beneficiary.get('userTitle').value === 'Other') {
      this.enableOtherTitle = true;
      othTitle.setValidators(Validators.required);
      this.getOtherTitle();
    } else {
      beneficiary.controls.otherTitle.setValue(null);
      this.enableOtherTitle = false;
      othTitle.setValidators(null);
      // this.otherTitle=null;
    }
    this.triggerotherTitleValidation();

  }

  /* method to save data on click of next */
  gotoNext() {
     
    this.getTotalError = false;
    if(this.beneficiaryDetailForm.value.beneficiary.length === 0) {
      this.store.dispatch(new beneficiaryDetailsActions.RemoveBeneficiaryDetails(0));
      this.store.dispatch(new beneficiaryDetailsActions.AddBeneficiaryDetails(this.beneficiaryDetailForm.value.beneficiary));
      this.router.navigate(['apply/your-payment-details']);
    }else 
    if (this.beneficiaryDetailForm.valid && (this.getTotal() < 100 || this.getTotal() > 100)) {
      this.getTotalError = true
    } else if (this.beneficiaryDetailForm.valid) {
      this.getTotalError = false;
      this.store.dispatch(new beneficiaryDetailsActions.RemoveBeneficiaryDetails(0));
      this.store.dispatch(new beneficiaryDetailsActions.AddBeneficiaryDetails(this.beneficiaryDetailForm.value.beneficiary));
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {

      });
      this.router.navigate(['apply/your-payment-details']);

    } else {
      FormValidationsService.validateAllFormFields(this.beneficiaryDetailForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      }, 0);
    }

  }

  /* method to scroll on incvalid fields when invalid and submitting the form */
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }

  
   displayTooltipMessage(){
      let config = this.firstNameToolTipInfoCodeConfig;
      this.tooltipModal.content = config.content.replace('<a', '<a class="moneyhelperTxt"');
      this.displayTooltipAlert = true;   
  }

   closeTooltipModal() {
    this.displayTooltipAlert = false;
  }

  
  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourBeneficaryDetailsApply;
    //console.log('changed value = ', );
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.alertModalConfig = new AlertModal('alert', this.CMSData.commonBlock.string_DependantRemovedPopUpTitle, this.CMSData.commonBlock.string_DependantRemovedPopUpText, this.CMSData.commonBlock.string_OKCTALabel, '', 'Don’t show this message again');
        this.contentData.header = this.CMSData.string_ApplyYourBeneficiaryDetailsTitle;
        this.contentData.guranteedIncomeText1 = this.CMSData.string_GuranteeSubTitle1;
        this.contentData.guranteedIncomeText2 = this.CMSData.string_GuranteeSubTitle2;
        this.contentData.VPText1 = this.CMSData.string_VPSubTitle1;
        this.contentData.VPText2 = this.CMSData.string_VPSubTitle2;
        this.contentData.addBeneficiary = this.CMSData.string_AddBeneficiary;
        this.contentData.beneficiaryDetails = this.CMSData.string_BeneficiaryDetails;
        this.contentData.beneficiary = this.CMSData.string_Beneficiary;
        this.contentData.remove = this.CMSData.string_Remove;
        this.contentData.addAnotherBeneficiary = this.CMSData.string_AddAnotherBeneficiary;
        this.contentData.step = this.CMSData.string_Step;
        this.contentData.manageAllocations = this.CMSData.string_ManageAllocations;
        this.contentData.payment = this.CMSData.string_payments;
        this.contentData.errorMessageText = this.CMSData.string_ErrorMessageText;
        this.contentData.totalAllocation = this.CMSData.string_TotalAllocation;
        this.contentData.sameAsMine = this.CMSData.string_SameAsMine;
        this.contentData.addressSearch = this.CMSData.string_AddressSearch;

        this.titleConfig.errorMessage = this.CMSData.commonBlock.string_TitleErrorMessageWording;
      }
    });
  }
  /** End of code block for CMS */

}


